import { Spinner } from 'baseui/spinner';
import dynamic from 'next/dynamic';
import { StakingPoolTable } from 'structure/staking/containers/StakingPoolTable';
import { useStakingPoolList } from 'structure/staking/hooks/useStakingAPI';
import { ViewTypes } from 'structure/multi-asset-staking/types';

const StakingCardView = dynamic(() => import('./StakingCardView'));

interface IStakingProjectsList {
  view: string;
}

export const StakingProjectsList = ({ view }: IStakingProjectsList) => {
  const stakingPoolList = useStakingPoolList();

  if (stakingPoolList.isLoading) {
    return (
      <div className='m-auto w-full p-8'>
        <Spinner $size='14px' $borderWidth='3px' />
      </div>
    );
  }

  return (
    <>
      {ViewTypes.CARD_VIEW === view ? (
        <StakingCardView stakingPoolList={stakingPoolList.data ?? []} />
      ) : (
        <StakingPoolTable
          pools={stakingPoolList.data ?? []}
          enableExplore={true}
        />
      )}
    </>
  );
};
